import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

type AnonymousClipperIdentityProps = {
  className?: string;
};

export function AnonymousClipperIdentity({
  className,
}: AnonymousClipperIdentityProps) {
  const { t } = useTranslation();

  return (
    <p
      data-testid="clipper-ranks-anonymous-name"
      aria-hidden="true"
      className={cn(
        'min-w-0 truncate text-sm font-semibold text-primary blur-sm select-none',
        className,
      )}
    >
      {t('cpmLeaderboard.anonymousName')}
    </p>
  );
}
